<mat-card class="cardWithShadow" style="margin: 0; height: 100%;overflow: hidden;border-radius: 0;">
  <mat-card-header class="w-100 d-block p-0" style="background-color: #1e293b;border-bottom: 3px solid #5d87ff;">
    <mat-card-title>
      <div class="w-100 d-flex" style="background: #0f172a;">
        <span style="display: flex; align-items: center; margin-left: 15px; color: #1bbaee; font-size: 14px;">{{ "Base de données embarquées - CashDesk" | translate }}</span>
        <button class="m-l-auto" mat-icon-button (click)="matDialogRef.close();">
          <i-tabler name="x" class="icon-18" style="color: #1bb3e6;"></i-tabler>
        </button>
      </div>
    </mat-card-title>
    <mat-card-title>
      <mat-form-field class="w-100" style="background: #0f172a;">
        <mat-icon matSuffix style="color: #1855d5; background: #0f172a; border-radius: 8px;">search</mat-icon>
        <input matInput [autocomplete]="'off'" [placeholder]="'Rechercher..'" class="cplaceholder" style="color: white;" #gridSearchInput>
      </mat-form-field> 
    </mat-card-title>
    <mat-card-subtitle style="background: #0f172a;color: white;" class="p-b-16">
      <div class="d-flex">
        <div class="d-flex flex">
          <div style="border-right: 2px solid #1855d5; margin-right: 15px;">
            <button mat-icon-button (click)="doExportRxDbAction_CashDesk()">
              <i-tabler name="download" class="icon-24 d-flex" style="color: #1cc8ff; align-items: center;"></i-tabler>
            </button>
          </div>
          <div class="d-grid">
            <span>Base de données embarquées</span>
            <span style="padding-top: 8px; font-size: 13px; color: #9b9b9f; font-weight: 600;">{{ linkupCollection?.name }} <span>{{ linkupCollection?.lib }}</span></span>
          </div>
        </div>
        <div class="m-l-auto">
          <button mat-stroked-button style="color: #1bbaee; font-weight: 700; border: 1px solid; margin-right: 10px;" [matMenuTriggerFor]="sOptions">
            {{ "SCHÉMA" | translate }}
          </button>
          <mat-menu #sOptions="matMenu" class="cardWithShadow">
            <ng-container *ngFor="let item of linkupCollections">
              <button mat-menu-item (click)="onLinkupCollectionPickedEvent(item);">
                <div class="d-flex align-items-center">
                  <i-tabler name="point" class="icon-24 d-flex" style="color: #375cff; margin-right: 10px;"></i-tabler>
                  <span class="mat-subtitle-1 f-s-12">{{ item.name }} <span style="color: #506cad; display: block;">{{ item.lib }}</span></span>
                </div>
              </button>
              <mat-divider></mat-divider>
            </ng-container>
          </mat-menu>
          <button (click)="cluGrid.saveAsExcel()" mat-stroked-button style="color: #1bee50; font-weight: 700; border: 1px solid; margin-right: 10px;">
            {{ "EXPORT EXCEL" | translate }}
          </button>
          <button [matTooltip]="'Réajustement des colonnes'" (click)="cluGrid.autoFitColumns();" mat-stroked-button style="color: #ee1b6c; font-weight: 700; border: 1px solid; margin-right: 10px;">
            {{ "COLONNES" | translate }}
          </button>
        </div>
      </div>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content style="flex: 1;padding: 0;">
    <div class="clientsGrid">
      <kendo-grid #cluGrid [data]="gridView" [skip]="state.skip" [pageSize]="state.take" scrollable="virtual" [rowHeight]="36" [height]="420" [sortable]="{ mode : 'multiple' }" [sort]="state.sort" [rowHeight]="36" [height]="height" (dataStateChange)="onDataChange($event)"
                  [resizable]="true" [autoSize]="true" [columnMenu]="{ lock: true, stick: true, setColumnPosition: { expanded: true }, autoSizeColumn: true, autoSizeAllColumns: true }" [loading]="loading">
        <ng-container *ngIf="linkupCollection">
          <ng-container *ngFor="let column of linkupCollection.columns">
            <ng-container [ngSwitch]="column.pName">
              <ng-container *ngSwitchCase="'ZSYNCUP_STATUS'">
                <kendo-grid-column [width]="150" field="ZSYNCUP_STATUS" title="ZSYNCUP_STATUS" [style]="{ 'font-weight': '600'}" [sticky]="true"> 
                  <ng-template kendoGridHeaderTemplate let-column><span style="width: 100px"> {{ column.title | translate }}</span></ng-template>
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <ng-container [ngSwitch]="dataItem.ZSYNCUP_STATUS">
                      <ng-container *ngSwitchCase="'pending'">
                        <span style="display: flex; align-items: center; font-size: 12px;">
                          <i-tabler name="square-rotated-filled" class="icon-24 d-flex" style="color: #4040d7; align-items: center;margin-right: 4px;"></i-tabler>
                          {{ "En attente" | translate }}
                        </span>
                      </ng-container>
                      <ng-container *ngSwitchCase="'sent'">
                        <span style="display: flex; align-items: center; font-size: 12px;">
                          <i-tabler name="square-rounded-arrow-up-filled" class="icon-24 d-flex" style="color: #cf1588; align-items: center;margin-right: 4px;"></i-tabler>
                          {{ "Envoyé" | translate }}
                        </span>
                      </ng-container>
                      <ng-container *ngSwitchCase="'in_progress'">
                        <span style="display: flex; align-items: center; font-size: 12px;">
                          <i-tabler name="square-rounded-arrow-right-filled" class="icon-24 d-flex" style="color: gold; align-items: center;margin-right: 4px;"></i-tabler>
                          {{ "En cours" | translate }}
                        </span>
                      </ng-container>
                      <ng-container *ngSwitchCase="'completed'">
                        <span style="display: flex; align-items: center; font-size: 12px;">
                          <i-tabler name="square-check-filled" class="icon-24 d-flex" style="color: #15cf37; align-items: center;margin-right: 4px;"></i-tabler>
                          {{ "Synchronisé" | translate }}
                        </span>
                      </ng-container>
                      <ng-container *ngSwitchCase="'error'">
                        <span style="display: flex; align-items: center; font-size: 12px;" [matTooltip]="dataItem.ZSYNCUP_ERROR_MESSAGE">
                          <i-tabler name="alert-triangle-filled" class="icon-24 d-flex" style="color: #d01f25; align-items: center;margin-right: 4px;"></i-tabler>
                          {{ "Erreur" | translate }}
                        </span>
                      </ng-container>
                      <ng-container *ngSwitchCase="'unknown'">
                        <span style="display: flex; align-items: center; font-size: 12px;">
                          <i-tabler name="alert-octagon-filled" class="icon-24 d-flex" style="color: #000000; align-items: center;margin-right: 4px;"></i-tabler>
                          {{ "Indéterminé" | translate }}
                        </span>
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        <span>{{ dataItem.ZSYNCUP_STATUS }}</span>
                      </ng-container>
                    </ng-container>
                  </ng-template>
                </kendo-grid-column>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <kendo-grid-column [width]="150" [field]="column.pName" [title]="column.pName" [hidden]="column.hidden">
                  <ng-template kendoGridHeaderTemplate let-column><span style="width: 100px"> {{ column.title | translate }}</span></ng-template>
                </kendo-grid-column>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
        <kendo-grid-excel fileName="CaurisLinkUp_RxDb.xlsx" [fetchData]="doGridFetchAllData"></kendo-grid-excel>
      </kendo-grid>
    </div>
  </mat-card-content>
  <mat-card-actions class="d-block m-0 p-0" style="background-color: #0f172a;border-top: 3px solid #5d87ff;">
    <div class="d-flex w-100" style="border-right: 3px solid #1855d5; margin-right: 15px;height: 100px;">
      <button mat-stroked-button style="color: #707387; font-weight: 700; border: 1px solid; margin-left: 10px; margin-right: 10px; flex: 1; margin-top: auto; margin-bottom: auto; height: 80px;" (click)="matDialogRef.close();">
        {{ "FERMER" | translate }}
      </button>
    </div>
  </mat-card-actions>
</mat-card>